import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { InheritedBadge } from './InheritedBadge';

interface CollapsibleSectionHeaderProps {
  icon: React.ElementType;
  title: string;
  /** Displayed inside the circle badge (number like "1" or letter like "A") */
  label: string | number;
  isOpen: boolean;
  onToggle: () => void;
  isInherited?: boolean;
  /** Badge background color class (default: blue for numbered sections) */
  badgeClassName?: string;
}

export const CollapsibleSectionHeader: React.FC<CollapsibleSectionHeaderProps> = ({
  icon: Icon,
  title,
  label,
  isOpen,
  onToggle,
  isInherited,
  badgeClassName = 'bg-blue-100 text-blue-700',
}) => (
  <button
    type="button"
    onClick={onToggle}
    className="flex items-center justify-between w-full p-4 text-left hover:bg-gray-50 transition-colors rounded-t-lg"
  >
    <div className="flex items-center gap-3">
      <div className={`flex items-center justify-center w-7 h-7 rounded-full text-xs font-semibold ${badgeClassName}`}>
        {label}
      </div>
      <Icon className="w-4 h-4 text-gray-500" />
      <span className="text-sm font-semibold text-gray-900">{title}</span>
      {isInherited && <InheritedBadge />}
    </div>
    {isOpen ? (
      <ChevronUp className="w-4 h-4 text-gray-400" />
    ) : (
      <ChevronDown className="w-4 h-4 text-gray-400" />
    )}
  </button>
);
